<template>
  <div>
    <b-loading :active.sync="loading" />
    <tabelaPadrao :titulo="'Motivos de Cancelamento de Fatura'" :colunas="colunas"
      :lista_dados="lista_fatura_motivo_cancelamento" :metodoBusca="listar_fatura_motivo_cancelamento"
      :tamanhoTela="tamanhoTela" :exbirAcoes="true" tamanhoAcoes="110px" :loadingTela="loading"
      @atualizarPagina="atualizarPagina">
      <template #botoes>
        <v-btn fab color="primary" small @click.native="openCreateModal">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>

      <template #filtros>
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <v-text-field dense v-model="filtros.nome" label="Nome" outlined clearable />
            '</v-col>
        </v-row>
      </template>

      <template #acoes="{ row }">
        <v-row class="justify-center pt-1">
          <v-btn fab color="primary" x-small class="mr-1" @click="openEditModal(row)">
            <v-icon color="white">mdi-pencil</v-icon>
          </v-btn>
          <v-btn fab color="error" x-small class="mr-1" @click="deleteMotivo(row)">
            <v-icon color="white">mdi-delete</v-icon>
          </v-btn>
        </v-row>
      </template>
      <template #empty>
        <Not-Found-Data text="Nenhum motivo encontrado" />
      </template>
    </tabelaPadrao>

    <v-dialog v-model="modalOpen" max-width="600px">
      <v-card>
        <v-card-title class="headline">
          Motivo Cancelamento Fatura
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field v-show="false" v-model="form.id" label="ID" outlined dense class="mb-2" />
            <v-text-field v-model="form.nome" label="Nome" placeholder="Insira o nome do motivo" outlined dense
              class="mb-2" />
            <v-text-field v-model="form.descricao" label="Descrição" placeholder="Insira a descrição" outlined dense
              class="mb-2" />
            <v-radio-group v-model="form.liberacao_financeiro_guia" label="Liberação Financeiro Guia" row class="mb-2">
              <v-radio label="Sim" :value="true"></v-radio>
              <v-radio label="Não" :value="false"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="confirm(!form.id ? 'cria' : 'edita')" small>
            {{ !form.id ? 'Criar' : 'Editar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "FaturaMotivoCancelamento",
  data() {
    return {
      loading: false,
      modalOpen: false,
      form: { id: null, nome: "", descricao: "" },
      colunas: [
        { label: "Nome", field: "nome", sortable: true },
        { label: "Descrição", field: "descricao", sortable: true },
      ],
      filtros: {
        nome: "",
        per_page: 10,
        page: 1,
      },
    };
  },
  watch: {
    'filtros.nome': function (newValue) {
      this.filtros.page = 1;
      this.$debounce('listarFatura', this.listar_fatura_motivo_cancelamento, 700);
    },
  },
  computed: {
    lista_fatura_motivo_cancelamento() {
      return this.$store.state.financeiro.lista_fatura_motivo_cancelamento;
    },
    tamanhoTela() {
      return "width:100%;";
    },
    mensagem_alert() {
      return this.$store.state.financeiro.mensagem_alert;
    },
  },
  methods: {
    async listar_fatura_motivo_cancelamento() {
      this.loading = true;
      const { filtros } = this;
      await this.$store
        .dispatch("financeiro/listar_fatura_motivo_cancelamento", filtros)
        .finally(() => (this.loading = false));
    },
    openCreateModal() {
      this.form = { id: null, nome: "", descricao: "" };
      this.modalOpen = true;
    },
    openEditModal(row) {
      this.form = { ...row };
      this.modalOpen = true;
    },
    async confirm(tipo) {
      await this.$confirm({
        title: `${tipo === "cria" ? "Criar" : "Editar"} motivo`,
        message: `Deseja ${tipo === "cria" ? "criar" : "editar"} este motivo?`,
        type: "is-success",
        confirmText: "Sim",
        cancelText: "Não",
        onConfirm: () => {
          if (tipo === "cria") this.create();
          if (tipo === "edita") this.update();
        },
      });
    },
    async create() {
      this.loading = true;
      await this.$store
        .dispatch("financeiro/create_fatura_motivo_cancelamento", this.form)
        .then(() => this.$snack.success(this.mensagem_alert.message))
        .catch(() => this.$snack.error(this.mensagem_alert.message))
        .finally(() => {
          this.loading = false;
          this.modalOpen = false;
          this.listar_fatura_motivo_cancelamento();
        });
    },
    async update() {
      this.loading = true;
      await this.$store
        .dispatch("financeiro/update_fatura_motivo_cancelamento", this.form)
        .then(() => this.$snack.success(this.mensagem_alert.message))
        .catch(() => this.$snack.error(this.mensagem_alert.message))
        .finally(() => {
          this.loading = false;
          this.modalOpen = false;
          this.listar_fatura_motivo_cancelamento();
        });
    },
    deleteMotivo(row) {
      this.$confirm({
        title: "Excluir motivo",
        message: "Deseja excluir este motivo?",
        type: "is-warning",
        confirmText: "Excluir",
        cancelText: "Cancelar",
        onConfirm: () => this.delete(row),
      });
    },
    async delete(row) {
      this.loading = true;
      await this.$store
        .dispatch("financeiro/delete_fatura_motivo_cancelamento", row)
        .then(() => this.$snack.success(this.mensagem_alert.message))
        .catch(() => this.$snack.error(this.mensagem_alert.message))
        .finally(() => {
          this.loading = false;
          this.listar_fatura_motivo_cancelamento();
        });
    },
    atualizarPagina(page) {
      this.filtros.page = page;
    },
  },
  created() {
    this.listar_fatura_motivo_cancelamento();
  },
};
</script>
